/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import LayoutFooter from "../inc/LayoutFooter";
import LayoutHeader from "../inc/LayoutHeader";
import { RollbackOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import { Layout, Col, Row, Rate } from "antd";
import { Button, Card, Form, Input, Spin } from "antd";
import { displayMessage, postAPI } from "../../utils/common";
import { ERROR_MSG_TYPE, SUCCESS_MESSAGE } from "../../constants/messages";
import { EDIT_TESTIMONIAL, TESTIMONIAL_BY_ID } from "../../constants/api";

function TestimonialUpdate() {
  const { Content } = Layout;
  const { id } = useParams();
  let history = useNavigate();
  let navigate = useNavigate();

  const [form] = Form.useForm();
  const [loading, setIsLoading] = useState(false);

  useLayoutEffect(() => {
    getIdDetail();
  }, []);
  const getIdDetail = () => {
    setIsLoading(true);
    var data = new FormData();
    data.append("id", id);
    const successFn = function (data) {
      if (data.status === true) {
        form.setFieldsValue({
          title: data.data.title,
          description: data.data.description,
          rating: parseFloat(data.data.rating),
        });
        setIsLoading(false);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Get Data");
    };
    postAPI(TESTIMONIAL_BY_ID, data, successFn, errorFn);
  };

  const updateData = (values) => {
    setIsLoading(true);
    const data = new FormData();
    data.append("id", id);
    if (values.title) {
      data.append("title", values.title);
    }
    if (values.description) {
      data.append("description", values.description);
    }
    if (values.rating) {
      data.append("rating", values.rating);
    }
    const successFn = function (data) {
      if (data.status === true) {
        setIsLoading(false);
        history("/testimonial");
        displayMessage(SUCCESS_MESSAGE, data.message);
      } else {
        setIsLoading(false);
        displayMessage(ERROR_MSG_TYPE, data.message);
      }
    };
    const errorFn = function () {
      setIsLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to Update Data");
    };
    postAPI(EDIT_TESTIMONIAL, data, successFn, errorFn);
  };
  return (
    <>
      <Layout>
        <LayoutHeader />
        <Content>
          <Card
            title="Update Testimonial"
            bordered={false}
            extra={
              <Button
                style={{
                  marginTop: "5px",
                  marginBottom: "5px",
                }}
                onClick={() => navigate(-1)}
                type="primary"
                ghost
              >
                <RollbackOutlined />
              </Button>
            }
          >
            <Spin spinning={loading}>
              <Form form={form} layout="vertical" onFinish={updateData}>
                <Row gutter={[16, 16]}>
                  <Col span={6}>
                    <Form.Item
                      name="title"
                      label="Title"
                      rules={[{ required: false }]}
                    >
                      <Input type={"text"} placeholder="Title" />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      name="description"
                      label="Description"
                      rules={[{ required: true }]}
                    >
                      <Input type={"text"} placeholder="Description" />
                    </Form.Item>
                  </Col>

                  <Col span={6}>
                    <Form.Item
                      name="rating"
                      label="Rating"
                      rules={[
                        { required: true, message: "Please input a rating!" },
                      ]}
                    >
                      <Rate
                        allowHalf
                        defaultValue={0}
                        max={5}
                        onChange={(value) => console.log(value)} // Use this callback to handle the value change
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row spceber>
                  <Col span={24}>
                    <Form.Item
                      style={{ float: "right" }}
                      label=""
                      colon={false}
                    >
                      <Button loading={loading} block htmlType="submit">
                        Update
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form>
            </Spin>
          </Card>
        </Content>
        <LayoutFooter />
      </Layout>
    </>
  );
}
export default TestimonialUpdate;
